import React from 'react'
import { Notyf } from 'notyf';

export default React.createContext(
    new Notyf({
        duration: 0,
        position: { x: "center", y: "top" },
        dismissible: true// Set your global Notyf configuration here
    })
);